import React from "react"
import { TransactionManager } from "../../../normal-user/tab"

export const ParterTransactionManager = () => {
  return <TransactionManager />
}
